import { useEffect, useRef, useState } from "react";

// HP Ürün Kataloğu embed'i (public/hp-katalog-embed.html)
// Embed birebir korunur (hiç düzenlenmez). iframe içeriğe göre otomatik büyür (kutu kaydırma yok,
// sayfayla akar). Embed içinde modal (position:fixed) açılınca, iframe geçici olarak tam ekran
// katmana dönüştürülür ki modal ekran ortasında doğru görünsün.
// Hem ana sayfa "Öne Çıkan Ürünlerimiz" bölümünde hem /projelerimiz sayfasında kullanılır.
export default function HpCatalogEmbed() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(900);
  const [modalActive, setModalActive] = useState(false);
  const modalRef = useRef(false);
  modalRef.current = modalActive;

  useEffect(() => {
    const f = iframeRef.current;
    if (!f) return;
    let ro: ResizeObserver | null = null;
    let mo: MutationObserver | null = null;

    const measure = () => {
      if (modalRef.current) return; // modal açıkken yüksekliği sabit tut (yer korunur)
      const doc = f.contentDocument;
      if (!doc) return;
      const h = Math.max(doc.documentElement?.scrollHeight || 0, doc.body?.scrollHeight || 0);
      if (h > 0) setHeight((prev) => (Math.abs(prev - h) > 1 ? h : prev));
    };

    const onLoad = () => {
      const doc = f.contentDocument;
      if (!doc) return;
      measure();
      try { ro = new ResizeObserver(measure); ro.observe(doc.documentElement); } catch { /* yoksay */ }
      const modal = doc.querySelector(".modal");
      if (modal) {
        const sync = () => setModalActive(modal.classList.contains("open"));
        mo = new MutationObserver(sync);
        mo.observe(modal, { attributes: true, attributeFilter: ["class"] });
        sync();
      }
    };

    f.addEventListener("load", onLoad);
    if (f.contentDocument && f.contentDocument.readyState === "complete") onLoad();
    const poll = setInterval(measure, 1200);
    return () => { f.removeEventListener("load", onLoad); ro?.disconnect(); mo?.disconnect(); clearInterval(poll); };
  }, []);

  return (
    <section className="bg-[#F5F7FA] border-t border-[#E2E8F0]">
      {/* Yer tutucu: modal tam ekrana geçtiğinde sayfanın zıplamaması için yükseklik korunur */}
      <div style={{ height: height + "px" }}>
        <iframe
          ref={iframeRef}
          src="/hp-katalog-embed.html"
          title="HP Ürün Kataloğu"
          scrolling="no"
          style={
            modalActive
              ? { position: "fixed", inset: 0, width: "100%", height: "100vh", border: 0, zIndex: 9999, background: "#F5F7FA" }
              : { width: "100%", height: "100%", border: 0, display: "block" }
          }
        />
      </div>
    </section>
  );
}
